var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _circle2, _circle3, _circle4, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScaleZurich(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-9.444 32 17.502)",
    d: "M4.628 16.5h54.745v2H4.628z",
    fill: "#e5e6eb",
    className: "fill-e5e6eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5h4v45h-4z",
    fill: "#e5e6eb",
    className: "fill-e5e6eb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5h2v45h-2z",
    fill: "#d9dae2",
    className: "fill-d9dae2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 4,
    rx: 2,
    ry: 2,
    width: 8,
    x: 28,
    y: 3,
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h-6a8 8 0 0 0-8 8v2h22v-2a8 8 0 0 0-8-8Z",
    fill: "#e5e6eb",
    className: "fill-e5e6eb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50h-2a8 8 0 0 0-8 8v2h2v-2a8 8 0 0 1 8-8Z",
    fill: "#ffffff",
    className: "fill-ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h-2a8 8 0 0 1 8 8v2h2v-2a8 8 0 0 0-8-8Z",
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 57h30v4H17z",
    fill: "#444444",
    className: "fill-444444"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43 57h4v4h-4z",
    fill: "#000000",
    className: "fill-000000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    r: 6,
    fill: "#d9dae2",
    className: "fill-d9dae2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.629 11.23a5.991 5.991 0 0 1-5.258 10.54 6 6 0 1 0 5.258-10.54Z",
    fill: "#cfcfd9",
    className: "fill-cfcfd9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    r: 2,
    fill: "#e5e6eb",
    className: "fill-e5e6eb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 21,
    r: 3,
    fill: "#d9dae2",
    className: "fill-d9dae2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 15,
    r: 3,
    fill: "#d9dae2",
    className: "fill-d9dae2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z",
    fill: "#000000",
    className: "fill-000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.249 31.257 53.618 18A3.975 3.975 0 0 0 55 15c0-.108-.023-.209-.032-.315l4.2-.7-.328-1.972-4.519.753a3.986 3.986 0 0 0-7.163 1.193L38.8 15.354a7.019 7.019 0 0 0-3.8-4.669V7.816A2.993 2.993 0 0 0 34 2h-4a2.993 2.993 0 0 0-1 5.816v2.869A7 7 0 0 0 25 17c0 .219.013.434.033.647l-8.55 1.425a3.978 3.978 0 0 0-7.413 1.236l-4.234.706.328 1.972 4.074-.679A3.989 3.989 0 0 0 10.382 24L3.789 37.176l1.789.894 6.585-13.161a3.895 3.895 0 0 0 1.674 0L20.46 38.09l1.789-.9L15.618 24A3.973 3.973 0 0 0 17 21.014l8.505-1.414A7.029 7.029 0 0 0 29 23.315V48a9.01 9.01 0 0 0-8.941 8H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-3.059A9.01 9.01 0 0 0 35 48V23.315a7 7 0 0 0 3.982-5.965l8.157-1.36A3.978 3.978 0 0 0 48.382 18l-6.654 13.269 1.789.9 6.646-13.255a3.89 3.89 0 0 0 1.673 0l6.624 13.238ZM11 21a2 2 0 1 1 2 2 2 2 0 0 1-2-2ZM30 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2Zm1 4h2v2.08a6.29 6.29 0 0 0-2 0Zm15 52H18v-2h28Zm-4.08-4H22.08A7.006 7.006 0 0 1 29 50h6a7.006 7.006 0 0 1 6.92 6ZM33 48h-2V23.92a6.29 6.29 0 0 0 2 0Zm-1-26a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5Zm17-7a2 2 0 1 1 2 2 2 2 0 0 1-2-2Z",
    fill: "#000000",
    className: "fill-000000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3 37h20v.92A3.08 3.08 0 0 1 19.92 41H6.08A3.08 3.08 0 0 1 3 37.92V37Z",
    fill: "#ff002b",
    className: "fill-027de5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v.92A3.08 3.08 0 0 1 17.92 41h2A3.08 3.08 0 0 0 23 37.92V37Z",
    fill: "#bf0020",
    className: "fill-0468ad"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31h20v.92A3.08 3.08 0 0 1 57.92 35H44.08A3.08 3.08 0 0 1 41 31.92V31Z",
    fill: "#ff002b",
    className: "fill-027de5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31v.92A3.08 3.08 0 0 1 55.92 35h2A3.08 3.08 0 0 0 61 31.92V31Z",
    fill: "#bf0020",
    className: "fill-0468ad"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleZurich);
export default __webpack_public_path__ + "static/media/scaleZurich.6852a0585da65a7133580c8467e68638.svg";
export { ForwardRef as ReactComponent };